module.exports = __webpack_public_path__ + "static/malanargia_galathea_schachbrett_haldenstein_070617_1-e76f351fd09e745298a60f9d79bd437f.jpg";